export default __webpack_public_path__ + "static/gray-fox-og-74238c13e3bd44afaa7555c939eaa3a9.jpg";